import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// ============================================================================
// Badge de Situacao (Sucesso / Erro) usado em listagens de logs de auditoria.
// Cores derivam do tema (palette.success / palette.error) — respeita whitelabel.
// ============================================================================

const LogSituacaoBadge = ({ flagSuccesso, codigoStatusCode }) => {
  const theme = useTheme();
  const success = flagSuccesso === true;
  const bg = success ? theme.palette.success.lighter : theme.palette.error.lighter;
  const color = success ? theme.palette.success.darker : theme.palette.error.darker;
  const border = success ? theme.palette.success.light : theme.palette.error.light;
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        py: 0.25,
        fontSize: '0.72rem',
        fontWeight: 600,
        borderRadius: 0.5,
        backgroundColor: bg,
        color,
        border: `1px solid ${border}`,
        lineHeight: 1.4,
        whiteSpace: 'nowrap'
      }}
    >
      {success ? 'Sucesso' : 'Erro'}
      {codigoStatusCode ? ` · ${codigoStatusCode}` : ''}
    </Box>
  );
};

export default LogSituacaoBadge;
